/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{invariant as e}from"../../../utils/errors.js";function r(r,t,o){var l;if("string"==typeof r){let n=document;t&&(e(Boolean(t.current),"Scope provided, but no element detected."),n=t.current),o?(null!==(l=o[r])&&void 0!==l||(o[r]=n.querySelectorAll(r)),r=o[r]):r=n.querySelectorAll(r)}else r instanceof Element&&(r=[r]);return Array.from(r||[])}export{r as resolveElements};
//# sourceMappingURL=resolve-element.js.map
